export default __webpack_public_path__ + "static/media/backIcon.db20c1fd.svg";